import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import { HeadingDisplay, ButtonBoxLaunch } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SectionError } from '@/modules/common/components/SectionError';

import { Portfolio } from '@/modules/wealth/services/portfolio';
import { isImpersonate } from '@/modules/common/services/partner';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  isLoading?: boolean;
  hasError?: boolean;
  portfolioDetails?: Portfolio;
}
interface Emits {
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    isLoading: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false },
    portfolioDetails: { default: undefined }
  },
  emits: ["on-retry"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoading: boolean, hasError: boolean, portfolioDetails: Portfolio }

const router = useRouter();
const route = useRoute();





const portfolioName = computed(() => {
  return props.portfolioDetails?.type.formatted;
});

const portfolioTotalGrossWorth = computed(() => {
  return props.portfolioDetails?.totalGrossWorth.formatted;
});

const portfolioTotalGrossWorthUpdateDate = computed(() => {
  return props.portfolioDetails?.updatedAt.formatted;
});

const hasImpersonate = computed(() => {
  const isImpersonateByIntranet = localStorage.getItem(
    StorageKeys.isImpersonateByIntranet
  );

  return isImpersonate() || isImpersonateByIntranet === 'true';
});

const canInvest = computed(() => {
  return !hasImpersonate.value;
});

const canWithdraw = computed(() => {
  return (
    !hasImpersonate.value && props.portfolioDetails?.totalGrossWorth.value > 0
  );
});

const portfolioId = computed(() => {
  const { portfolioId } = route.params;

  return portfolioId;
});

const emitOnRetry = () => {
  emits('on-retry');
};

function goToInvestment() {
  router.push({
    name: 'variableIncomeInvestment',
    params: { id: portfolioId.value }
  });
}

function goToWithdraw() {
  router.push({
    name: 'variableIncomeWithdraw',
    params: { id: portfolioId.value }
  });
}

return { __sfc: true,router, route, props, emits, portfolioName, portfolioTotalGrossWorth, portfolioTotalGrossWorthUpdateDate, hasImpersonate, canInvest, canWithdraw, portfolioId, emitOnRetry, goToInvestment, goToWithdraw, HeadingDisplay, ButtonBoxLaunch, Money, HeadingDisplayLoader, SectionError }
}

})